import { defineMessages } from 'react-intl';

export default defineMessages({
    headerLogoAlt: {
        id: 'gw-capability-quoteandbind-common-react.components.WMICCustomerHeader.Header Logo Alt',
        defaultMessage: 'Wawanesa Insurance'
    },
});
